import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  timeout: 20000,
});

export const teamLogoUrl = (slug) => `${API_BASE}/teams/${slug}/logo`;
export const teamOgImageUrl = (slug) => `${API_BASE}/teams/${slug}/og-image.png`;
export const newsOgImageUrl = (id) => `${API_BASE}/news/${id}/og-image.png`;
